import { render, staticRenderFns } from "./AutomatedResponsesSettings.vue?vue&type=template&id=6d5c2b2e&"
import script from "./AutomatedResponsesSettings.vue?vue&type=script&lang=js&"
export * from "./AutomatedResponsesSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedResponsesSettings.vue?vue&type=style&index=0&id=6d5c2b2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports